import { Box, Typography } from "@mui/material";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import { QuoteServiceItem } from "./QuoteServiceItem";
import { quoteModern } from "../style/style";

export const QuoteServicesRenderer = ({ quote, role, selectedTimes, onSelectTime }) => {
  if (!quote) return null;

  const type = quote?.type?.toLowerCase?.();
  const quoteIsApproved = quote?.status === "approved";
  const services = quote.services || [];
  const scopeOfWorkUri = Array.isArray(quote.scopeOfWorkUri) ? quote.scopeOfWorkUri : [];
  const safeSelectedTimes = selectedTimes || {};

  return (
    <Box sx={{ ...quoteModern.cardSx, mb: 2.5 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
        <Box sx={quoteModern.iconBoxSx}>
          <WorkOutlineIcon sx={{ fontSize: 18 }} />
        </Box>

        <Box>
          <Typography sx={quoteModern.labelSx}>Services</Typography>
          <Typography
            sx={{
              mt: 0.5,
              fontSize: 15,
              fontWeight: 800,
              color: quoteModern.colors.textPrimary,
              lineHeight: 1.2,
            }}
          >
            Services included in this estimate
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        {services.map((service, index) => (
          <QuoteServiceItem
            key={service.serviceUid || `service-${index}`}
            role={role}
            service={service}
            scopeOfWorkUrl={scopeOfWorkUri[index] || null}
            quoteId={quote.id}
            variant={type}
            selectedTime={safeSelectedTimes[service.serviceUid]}
            onSelectTime={onSelectTime}
            quoteIsApproved={quoteIsApproved}
          />
        ))}
      </Box>
    </Box>
  );
};
